import cn from 'classnames';
import IconWrapper from '@components/ui/Icons';
import { useTranslation } from 'next-i18next';
import styles from './DropdownMenu.module.scss';

export interface DropdownMenuProps {
  id: string;
  classNames?: string | string[];
  defaultText?: string;
  selectedOption?: string | number;
  data: {
    name?: string | null;
    value?: string | number | null;
    disabled?: boolean;
  }[];
  handleChange: (value: string) => void;
  hasError?: boolean;
  disabledText?: string;
  /** Optional id of an element that describes the control (e.g. validation error). */
  describedBy?: string;
}
const unselectedCode = '0';

const DropdownMenu = ({
  id,
  classNames,
  defaultText = '',
  selectedOption = unselectedCode,
  data,
  handleChange,
  hasError,
  disabledText,
  describedBy,
}: DropdownMenuProps) => {
  const { t } = useTranslation('pdp');

  return (
    <div className={cn(styles.container, classNames)}>
      <select
        id={id}
        value={selectedOption}
        className={cn(styles.select, { [styles.selectHasError]: hasError })}
        aria-describedby={describedBy}
        onChange={(e) => handleChange(e.target.value)}
      >
        {data && data.length !== 0 && defaultText && (
          <option value={unselectedCode} disabled>
            {defaultText}
          </option>
        )}
        {data?.map(({ name, value, disabled }) => (
          <option
            key={`option-${name}`}
            value={value || undefined}
            disabled={disabled}
          >
            {disabled
              ? `${name} ${disabledText ?? t('product.unavailable')}`
              : name}
          </option>
        ))}
      </select>
      <IconWrapper
        classNames={styles.icon}
        icon="caret-down"
        width={18}
        height={18}
      />
    </div>
  );
};

export default DropdownMenu;
